// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { BRAZILIAN_STATES } from '@tectonics/prs/brazil';

export function validateBrazilianState(stateValue: string): ?UserInputValidationError {
  if (!stateValue || stateValue.length === 0) {
    return { id: 'empty' };
  } else if (!validStateValue(stateValue)) {
    return { id: 'invalid-state' };
  }
}

function validStateValue(stateValue: string): boolean {
  return BRAZILIAN_STATES.find((data) => data.code === stateValue) !== undefined;
}
